import {
  isPossiblePhoneNumber,
  isValidPhoneNumber,
  CountryCode,
} from 'libphonenumber-js';

interface IValidatePhoneNumber {
  value: string;
  regionCode: string;
}

/**
 * Validates the phone number based on the region code.
 *
 * NOTE: Because `google-libphonenumber` compiles to native cod `Java, C++ and JS`
 *       it breaks next15 edge runtime so planning on moving away from this lib
 *       in the future.
 * - (Read More >> Introduction)https://www.npmjs.com/package/google-libphonenumber
 * - (Issue >> ref) https://github.com/ruimarinho/google-libphonenumber/issues/419
 * - (Alternative 1 >> https://www.npmjs.com/package/libphonenumber-js
 * - (Alternative 2 >> https://www.npmjs.com/package/awesome-phonenumber
 */
export function validatePhoneNumber({
  value,
  regionCode,
}: IValidatePhoneNumber) {
  try {
    // Remove leading zeroes from the phone number
    const phone = value.replace(/^0+/, '');

    if (isValidPhoneNumber(phone, regionCode as CountryCode)) return true;

    if (isPossiblePhoneNumber(phone, regionCode as CountryCode)) return true;

    return false;
  } catch (error: unknown) {
    const err = error as Error;
    // eslint-disable-next-line no-console
    console.error('Error validating phone number:', err);

    return false;
  }
}
